import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import RubriqDocumentCardStatus from './RubriqDocumentCardStatus';
import RubriqDocumentCardActions from './RubriqDocumentCardActions';
var RubriqDocumentCard = function RubriqDocumentCard(_ref) {
  var document = _ref.document,
    status = _ref.status,
    pagination = _ref.pagination,
    _ref$isTranslation = _ref.isTranslation,
    isTranslation = _ref$isTranslation === void 0 ? false : _ref$isTranslation,
    onDownload = _ref.onDownload;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center border p-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1 d-flex flex-column gap-1 me-3",
    style: {
      minWidth: '0',
      maxWidth: '50%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-2",
    style: {
      minWidth: '0'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-file-word"
  }), /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-5 text-truncate"
  }, document.file.name)), /*#__PURE__*/React.createElement("div", {
    className: "ms-2",
    style: {
      paddingLeft: '11.25px' /* skip icon width */
    }
  }, /*#__PURE__*/React.createElement(RubriqDocumentCardStatus, {
    document: document,
    isTranslation: isTranslation
  }))), /*#__PURE__*/React.createElement(RubriqDocumentCardActions, {
    document: document,
    status: status,
    pagination: pagination,
    isTranslation: isTranslation,
    onDownload: onDownload
  }));
};
export default RubriqDocumentCard;